/** @format */

export interface Warranty {
  athleteDescription: WarrantyAthleteDescription;
  planDisplayName: string;
  planEcode: string;
  planLength: number;
  planSku: string;
  sellingPrice: number;
  upc: string;
  styleNumber: string;
  teammateDescription: WarrantyTeammateDescription;
  aemContentIdentifier?: string;
  message?: string;
}

interface WarrantyTeammateDescription {
  coverageIncludes: string[];
  coverageTerms: string[];
  subtitle: string;
  title: string;
}

interface WarrantyAthleteDescription {
  ecommAbbreviation: string;
  ecommPlanDisplayName: string;
  title: string;
}

export interface SelectedAddOn {
  sku: string;
  qty: number;
  type: string;
}
